import React, { useContext, useState } from 'react'
import AuthContext from '../context/AuthContext'
import useAxios from '../utils/useAxios'
function AddCustomer() {
    const {baseURL} = useContext(AuthContext)
    const [forms, setForms] = useState({
        'name': '',
        'email': '',
        'phone_number': '',
        'statuss': ''
    })

    const handleChange = (event) => {
        setForms({
            ...forms,
            [event.target.name]: event.target.value,
            "statuss":''
        })
    }
    const api = useAxios()
    const submitForm = () => {
        const formdata = new FormData()
        formdata.append('name', forms.name)
        formdata.append('email', forms.email)
        formdata.append('phone_number', forms.phone_number)
        try {
            api.post(`${baseURL}/api/registercustomer/`, formdata).then((response) => {
                setForms({
                    'name': '',
                    'email': '',
                    'phone_number': '',
                    'statuss': 'success'
                })
            }).catch(()=>{
                setForms({
                    'name': '',
                    'email': '',
                    'phone_number': '',
                    'statuss':'error'
                })
            })
        } catch {
        }
    }





    return (
        <div style={{'margin':'auto'}}>
            {forms.statuss === 'success' && <p style={{'backgroundColor':'green','color':'white','marginBottom':'1rem'}}>Successfully Added</p>}
            {forms.statuss === 'error' && <p style={{'backgroundColor':'red','color':'white','marginBottom':'1rem'}}> &#128054; Data Not Added</p>}
              <h1 className='addcustomerheader'>Add New Customer</h1>
            <div className="formbox4">
                <div>
                    <form className='formcontainer2'>
                        <label htmlFor="" className='addcustomerheader2'>Full Name</label> 
                            <input value={forms.name} name="name" required onChange={handleChange} type="text" className="checkInSearch3"/>
                        <label htmlFor="" className='addcustomerheader2'>Email</label>
                            <input value={forms.email} name="email" onChange={handleChange} type="text" className="checkInSearch3" />
                        <label htmlFor="" className='addcustomerheader2'>Phone No.</label>
                            <input value={forms.phone_number} name="phone_number" onChange={handleChange} type="number" className="checkInSearch3" required/>
                    </form>
                    <div style={{'margin':'25px auto'}}>
                        <button onClick={submitForm} className='checkInSubmit3'>ADD</button>
                    </div>

                </div>
            </div>

        </div>
    );

}

export default AddCustomer